// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { loginWithToken } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        loginWithToken(data.token, data.user);
        // clear the hash
        window.history.replaceState(null, "", window.location.pathname);
        nav("/dashboard", { replace: true });
      } catch (e) {
        console.error("Auth callback error", e);
        nav("/login?error=google", { replace: true });
      }
    })();
  }, [nav, loginWithToken]);

  return (
    <div className="min-h-screen flex items-center justify-center text-white/70">
      Signing you in…
    </div>
  );
}
